import React from 'react'
import Layout from '../../components/layout'
import PrepaidSidebar from '../../components/prepaid-sidebar'
import { StaticImage } from 'gatsby-plugin-image'
import Seo from '../../components/seo'

export default function Flow(): JSX.Element {
  return (
    <Layout>
      <Seo
        title={'入会・切替方法｜トライアルプリペイドカード｜TRIAL -トライアル-'}
        description={
          'トライアルプリペイドカードの入会と切替のお手続きについてご紹介します。'
        }
        canonical={'https://www.trial-net.co.jp/prepaid/flow/'}
      />
      <div className="flow">
        <div className="flow-title-wrapper">
          <h1 className="flow-title">
            トライアル
            <br className="sp-new-line" />
            プリペイドカード
          </h1>
        </div>
        <div className="flow-container">
          <article className="flow-main">
            <h2 className="flow-main__title">入会・切替方法</h2>
            <section className="flow-main__process">
              <h3 className="flow-main__process-title">
                トライアルプリペイドカード入会のお手続き
              </h3>
              <div className="flow-main__line" />
              <p className="flow-main__process-text">
                トライアルプリペイドカードをご希望のお客様は、トライアルの店舗のサービスカウンターでお手続きをお願い致します。
              </p>
              <p className="flow-main__process-sm-text">
                ※一部サービスカウンターがない店舗もございます。その場合は、レジの担当者にお声がけください。
              </p>
            </section>
            <div className="flow-main__step">
              <div className="flow-main__step-row">
                <StaticImage
                  src="../../images/flow_img01.png"
                  alt=""
                  className="flow-main__img"
                  objectFit={'contain'}
                />
                <div className="flow-main__step-row-inner">
                  <p className="flow-main__step-row-text">
                    トライアル店舗のサービスカウンターへ
                  </p>
                </div>
              </div>
              <div className="flow-main__arrow-wrapper">
                <div className="flow-main__arrow" />
              </div>
              <div className="flow-main__step-row">
                <StaticImage
                  src="../../images/flow_img02.png"
                  alt=""
                  className="flow-main__img"
                  objectFit={'contain'}
                />
                <div className="flow-main__step-row-inner">
                  <p className="flow-main__step-row-text">
                    トライアルプリペイドカードを受け取る
                  </p>
                </div>
              </div>
              <div className="flow-main__arrow-wrapper">
                <div className="flow-main__arrow" />
              </div>
              <div className="flow-main__step-row">
                <StaticImage
                  src="../../images/flow_img03.png"
                  alt=""
                  className="flow-main__img"
                  objectFit={'contain'}
                />
                <div className="flow-main__step-row-inner">
                  <p className="flow-main__step-row-text">
                    入会端末で会員情報を登録する
                  </p>
                  <p className="flow-main__step-row-sm-text">
                    ※旧ポイントカードをお持ちのお客様は、案内に従い、カードをスキャンしてください。
                  </p>
                </div>
              </div>
            </div>
            <section className="flow-main__sp-flow">
              <StaticImage
                src="../../images/flow_img04.png"
                alt=""
                className="flow-main__sp-flow-img"
                objectFit={'contain'}
              />
              <div className="flow-main__sp-flow-inner">
                <h4 className="flow-main__sp-flow-text">
                  カードを持ち帰り、スマホでも会員登録ができます。
                </h4>
                <p className="flow-main__sp-flow-notice">
                  ※会員情報をご登録頂くと、カード紛失時に再発行ができます。
                </p>
                <p className="flow-main__sp-flow-notice">
                  ※再発行カードに引き継ぐチャージ残高、ポイントは、ご本人確認時点でのものになります。
                </p>
              </div>
            </section>
          </article>
          <PrepaidSidebar />
        </div>
      </div>
    </Layout>
  )
}
